module.exports = __webpack_public_path__ + "img/step2.44e50ff5.png";